import { useEffect, useState } from 'react';
import { API, trackView } from '@vfit/shared/data-access';
import {
  CONSUMER_CMS_SHOPPING_CART,
  useCmsConfig,
  ITermsAndCondition,
  usePrivacyProfile,
} from '@vfit/consumer/data-access';
import { IPartyPrivacyItem } from '@vfit/shared/models';
import { useConsentsFlow } from '@vfit/consumer/hooks';
import { resetData } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { Consents, Skeleton } from '@vfit/shared/components';
import { organizePrivacyItems, organizeTermsAndConditionConsentCard } from './consentCard.utils';
import { ICheckoutData } from '../../checkout.models';
import { useCheckout } from '../../../iBuyMobile.context';
import { ID_FLOWS } from '../../checkout.constants';
import { skeletonShape } from './consentCard.style';
import TaggingConsentCard from './consentCard.tagging';
import { useVoucheDefault } from '../../hooks/UseVoucherDefault/useVoucherDefault';

const ConsentCard = ({ handleOnChangeEnableGoNext, handleGoNextSlide }: ICheckoutData) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { consents, setConsents, setCurrentStepKey } = useCheckout();
  const queryClient = useQueryClient();
  const { partyPrivacyItems } = useConsentsFlow();
  const privacyProfile = usePrivacyProfile();
  useVoucheDefault();

  const consentsCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_TERMS_AND_CONDITIONS_MOBILE
  ) as ITermsAndCondition;
  const { title, terms, description, actionText, modal } =
    organizeTermsAndConditionConsentCard(consentsCms);

  const onUpdateConsents = (updatedConsents: IPartyPrivacyItem[], goNext: boolean) => {
    setConsents({ partyPrivacyItems: updatedConsents });
    privacyProfile.mutate(updatedConsents);
    if (handleGoNextSlide && goNext) handleGoNextSlide();
  };

  useEffect(() => {
    if (consents.partyPrivacyItems.length === 0) {
      setConsents({ partyPrivacyItems });
    }
  }, [consents, partyPrivacyItems]);

  useEffect(() => {
    // resetting payment data
    resetData(queryClient, ['authorize', 'reserveEquipment']);
    setCurrentStepKey(ID_FLOWS.CONSENTS);
    if (handleOnChangeEnableGoNext) {
      handleOnChangeEnableGoNext(true);
    }
  }, []);

  useEffect(() => {
    if (partyPrivacyItems.length > 0) {
      setIsLoading(false);
    }
  }, [partyPrivacyItems]);

  return (
    <>
      <TaggingConsentCard />
      {isLoading && <Skeleton {...skeletonShape} />}
      {!isLoading && (
        <Consents
          title={title}
          description={description}
          terms={terms}
          partyPrivacyItems={organizePrivacyItems(consents.partyPrivacyItems, modal.list)}
          actionText={actionText}
          onUpdateConsents={onUpdateConsents}
          trackView={trackView}
          modal={modal}
        />
      )}
    </>
  );
};

export default ConsentCard;

